import {AppRegistry} from 'react-native';
import '@fe-progressive/package-progressive/wallet-web-new/style.css';
import '@fe-progressive/package-progressive/recharge-web/style.css';
import '@fe-progressive/package-progressive/withdraw/style.css';
import '@fe-progressive/package-progressive/progressive-toast/style.css';
import '@fe-progressive/package-progressive/progressive-loading/style.css';
import App from './App';
import './index.scss';

import './theme.css';
// 暂时打开log
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
  console.dir = () => {};
  console.table = () => {};
  console.group = () => {};
}

AppRegistry.registerComponent('App', () => App);

AppRegistry.runApplication('App', {
  rootTag: document.getElementById('root'),
});
